import { lazy, Suspense, useEffect, useState, type ReactNode } from 'react';
import { useLocation } from 'react-router';
import { isNewsletterMarketingPathname } from '@/routes';
import { RootHydrateFallback } from '@/components/RouteHydrateFallbacks/RootHydrateFallback';
import { usePendingFormRedirect } from '@/hooks/usePendingFormRedirect';
import AccountRouteFrameBoundary from './AccountRouteFrameBoundary';

const ApplicationRuntime = lazy(() => import('./ApplicationRuntime'));

/** Load player services on first application entry, then retain their session state. */
export default function RouteExperience({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  const marketing = isNewsletterMarketingPathname(pathname);
  const [applicationStarted, setApplicationStarted] = useState(!marketing);
  usePendingFormRedirect();

  useEffect(() => {
    document.documentElement.setAttribute('data-hydrated', 'true');
    if (!marketing) setApplicationStarted(true);
  }, [marketing]);

  if (marketing && !applicationStarted) return children;

  return (
    <Suspense fallback={<RootHydrateFallback />}>
      <ApplicationRuntime marketing={marketing}>
        <AccountRouteFrameBoundary>{children}</AccountRouteFrameBoundary>
      </ApplicationRuntime>
    </Suspense>
  );
}
